var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNamuLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1023 1023",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#65a20d;}.cls-2{fill:#221e1f;}.cls-3{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -0.5,
    y: -0.5,
    width: 1024,
    height: 1024,
    transform: "translate(0 1023) rotate(-90)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M345.79,686C182.19,644.52,103.26,484.38,95.12,409.25c-8.33-76.91,5.27-220.69,135.9-237.76C343.48,156.8,405.16,252,400,367.83c-5,112.58,17.83,131.54,19.14,132.52a280.46,280.46,0,0,1-34.07-15.11,40.1,40.1,0,0,0-58.31,23.41,37,37,0,0,0-.35,19.05c.08.38.2.74.29,1.06a68.36,68.36,0,0,0,9.81,19.94c22.07,31.17,122,184,48.11,299.36C298.74,837,239.49,811.17,239.49,811.17c-12.5-6.79-21-19-21-34.25a46.41,46.41,0,0,1,.74-7.61c3.41-17.66,15.06-32.59,31-41,11.8-6.19,30-14.54,56.74-24A207.06,207.06,0,0,0,345.79,686Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M384.63,848.06c73.86-115.37-26-268.19-48.11-299.36a68.36,68.36,0,0,1-9.81-19.94c-.09-.32-.21-.68-.29-1.06a37,37,0,0,1,.35-19.05,40.1,40.1,0,0,1,58.31-23.41,280.46,280.46,0,0,0,34.07,15.11.09.09,0,0,0,.06,0c22.19,8.27,45.74,14.49,68,19.14a705.31,705.31,0,0,0,100.32,13.39c-24.86-21.51-38.28-47.16-45.3-71.7-13.45-46.9-3.44-89.56-5-90.65-1.75-1.25-34.13-44.71-7.58-67.91,20.77-18.13,55,20.47,55,20.47a144.53,144.53,0,0,1,27.19-12.89,132.39,132.39,0,0,1,59.76-6.51c75.85,9,136.76,78.72,135.75,109.56-1.66,51.22-63.43,94.36-63.43,94.36,37.09-6.7,128.4-51.37,128.4-51.37A40.07,40.07,0,0,1,926.63,508C791.15,839.2,542.72,868.47,384.63,848.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M671.57,303.72a132.39,132.39,0,0,0-59.76,6.51l-.09-.29s-9.89-30.84,10.37-42.84S669.56,299.45,671.57,303.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M542.19,461.21c7,24.54,20.44,50.19,45.3,71.7a705.31,705.31,0,0,1-100.32-13.39v0a40.19,40.19,0,0,1,55-58.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M776.25,390.21v15.1a7.55,7.55,0,0,1-10.52,6.91l-18.05-7.81a7.53,7.53,0,0,1,.19-13.89l18-7.3A7.53,7.53,0,0,1,776.25,390.21Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNamuLogo);
export default __webpack_public_path__ + "static/media/namu-logo.27bee74c1afda08c8776b29a52f2689a.svg";
export { ForwardRef as ReactComponent };